import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '../ui/card';
import { createAuthAPI } from '../../utils/api';
import { Sparkles } from 'lucide-react';

const MotivationalQuote = () => {
  const [quote, setQuote] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const abortController = new AbortController();

    const loadQuote = async () => {
      try {
        const api = createAuthAPI();
        const response = await api.get('/client/motivational-quote', {
          signal: abortController.signal
        });
        if (isMounted) {
          setQuote(response.data.quote);
        }
      } catch (error) {
        if (error.name !== 'AbortError' && isMounted) {
          setQuote('¡Tu bienestar es tu mayor tesoro! Cada día es una nueva oportunidad.');
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadQuote();

    return () => {
      isMounted = false;
      abortController.abort();
    };
  }, []);

  const loadQuote = async () => {
    try {
      const api = createAuthAPI();
      const response = await api.get('/client/motivational-quote');
      setQuote(response.data.quote);
    } catch (error) {
      setQuote('¡Tu bienestar es tu mayor tesoro! Cada día es una nueva oportunidad.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Card className="motivational-card">
        <CardContent className="py-6">
          <p className="text-center">Cargando frase motivacional...</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="motivational-card fade-in" data-testid="motivational-quote-card">
      <CardContent className="py-6">
        <div className="flex items-start gap-4">
          <Sparkles className="h-8 w-8 text-yellow-600 flex-shrink-0" />
          <div>
            <p className="text-lg font-medium text-amber-900 leading-relaxed">{quote}</p>
            <p className="text-sm text-amber-700 mt-2">— Tu equipo de Farmacia Tarin</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default MotivationalQuote;